import { Routes } from '@angular/router';
import { UserPolicyComponent } from './user-policy/user-policy.component';
import { ItemDetailComponent } from './item-detail/item-detail.component';
import { FaqComponent } from './faq/faq.component';
import { LdkDetailComponent } from './ldk-detail/ldk-detail.component';
import { QuestantRedirectComponent } from './questant-redirect/questant-redirect.component';
var routes = [
    { path: 'item-detail', component: ItemDetailComponent },
    { path: 'user-policy', component: UserPolicyComponent },
    { path: 'faq', component: FaqComponent },
    { path: 'ldk-detail', component: LdkDetailComponent },
    { path: 'questant-redirect', component: QuestantRedirectComponent }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
